import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=063deafe&scoped=true&lang=pug"
import script from "./TableOfContents.vue?vue&type=script&lang=ts"
export * from "./TableOfContents.vue?vue&type=script&lang=ts"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=063deafe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063deafe",
  null
  
)

export default component.exports